import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        ""
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useViewModel } from "@/lib/viewModels";
import { ProtectDescriptionViewModel } from "./ProtectDescriptionViewModel";
import styled from "styled-components";
import { observer } from "mobx-react-lite";
import { ProtectDescription } from "./ProtectDescription";
import { useApiService } from "@/lib/apiService";
const ProtectDescriptionViewWrapper = styled.div.withConfig({
    componentId: "sc-b6fd5fe2-0"
})(_templateObject());
export const ProtectDescriptionView = observer((props)=>{
    const apiService = useApiService();
    const { status , actions  } = useViewModel({
        apiService
    }, ProtectDescriptionViewModel);
    return /*#__PURE__*/ _jsx(ProtectDescriptionViewWrapper, {
        children: /*#__PURE__*/ _jsx(ProtectDescription, {
            onClick: ()=>status.modalOpen = !status.modalOpen,
            modalOpen: status.modalOpen,
            initialValues: status.initialValues,
            onSubmit: actions.onSubmit,
            publisherOptions: actions.publisherOptions,
            onSetImageFile: actions.onSetImageFile,
            onSetPdfFile: actions.onSetPdfFile
        })
    });
});
